module.exports = __webpack_public_path__ + "static/media/P1000_Micropipette.bd00e732.svg";